import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routes'

const router = createRouter({
    history: createWebHashHistory(),
    routes
})

router.beforeEach((to, from, next) => {
    localStorage.setItem('lastPath', '#' + from.path);

    if (to.matched.some((route) => route.meta?.requiresAuth)) {
        if (to.path === '/') {
            next('/tasks');
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router